import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartController } from '../../core/controllers/cart.controller';
import { CartPaymentDTO } from '../../core/interfaces/cart-payment';
import { CartPaymentStateEnum } from '../../core/enums/cart-payment-state.enum';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-thank-you-page',
  templateUrl: './thank-you-page.component.html',
  styleUrls: ['./thank-you-page.component.scss'],
  providers: [CartController],
})
export class ThankYouPageComponent implements OnDestroy {

  paymentImageSrc: string | null = null;
  paymentMessage: string | null = null;
  isLoading: boolean = false;

  private destroy$ = new Subject<void>();
  private readonly MAX_RETRIES = 5;
  private readonly RETRY_DELAY_MS = 7000;

  constructor(
    private activatedRoute: ActivatedRoute,
    private cartController: CartController
  ) {

    this.activatedRoute
      .queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(p => {

        // Nuova logica con transactionCode
        if (p.transactionCode) {

          this.handleTransactionCode(p.transactionCode, p.macroTypes);

        }
        // Vecchia logica con paymentSuccess (backward compatibility)
        else if (p.paymentSuccess && p.paymentSuccess === 'true') {

          this.setSuccessData(p);

        } else if (p.paymentSuccess) {

          this.setFailureData();

        }

      });

  }

  ngOnDestroy(): void {

    this.destroy$.next();
    this.destroy$.complete();

  }

  private handleTransactionCode(transactionCode: string, macroTypes?: string): void {

    this.isLoading = true;
    this.checkPaymentStatus(transactionCode, macroTypes, 1);

  }

  private checkPaymentStatus(transactionCode: string, macroTypes: string | undefined, attempt: number): void {

    this.cartController
      .getCartPaymentStatus(transactionCode)
      .then((payment: CartPaymentDTO) => {

        if (payment.State === CartPaymentStateEnum.Success) {

          this.isLoading = false;
          this.setSuccessData({ macroTypes });

        } else if (payment.State === CartPaymentStateEnum.Error) {

          this.isLoading = false;
          this.setFailureData();

        } else {

          // Stati: Waiting o WaitingValidation
          if (attempt < this.MAX_RETRIES) {

            // Retry dopo 5 secondi
            timer(this.RETRY_DELAY_MS)
              .pipe(takeUntil(this.destroy$))
              .subscribe(() => {

                this.checkPaymentStatus(transactionCode, macroTypes, attempt + 1);

              });

          } else {

            // Dopo 3 tentativi mostra messaggio di attesa
            this.isLoading = false;
            this.setWaitingValidationData();

          }

        }

      })
      .catch((error) => {

        this.isLoading = false;
        
        // Se l'errore è una stringa (es: "Pagamento non trovato"), mostrala
        if (typeof error === 'string') {

          this.setFailureData(error);

        } else {

          this.setFailureData();

        }

      });

  }

  private setWaitingValidationData(): void {

    this.paymentImageSrc = '/assets/images/thank-you-page/payment_success.svg';
    this.paymentMessage = 'Il tuo pagamento è in fase di validazione.<br/><br/>Potrai verificare lo stato del tuo ordine accedendo al tuo profilo nella sezione "I miei acquisti".';

  }

  private setFailureData(errorMessage?: string) {

    this.paymentImageSrc = '/assets/images/thank-you-page/payment_failed.svg';
    this.paymentMessage = errorMessage || 'Il tuo pagamento non è andato a buon fine';

  }

  private setSuccessData(p: any) {

    this.paymentImageSrc = '/assets/images/thank-you-page/payment_success.svg';

    this.paymentMessage = 'Il tuo pagamento è andato a buon fine.';

    if (p.macroTypes) {

      if (p.macroTypes.includes('Subscription')) {

        this.paymentMessage += '<br/> Buona stagione agonistica.';

      }

      if (p.macroTypes.includes('Merchandising')) {

        this.paymentMessage += '<br/> Il tuo ordine di materiale è stato inoltrato via mail alla segreteria e al nostro fornitore.';

      }

    }

    this.paymentMessage += '<br/><br/><br/><small class=\'text-center\'>Le ricevute saranno disponibili 24H dopo l\'acquisto nell\'apposita sezione "I miei acquisti" della tua area personale.</small>';

  }

}
